import { useState } from 'react';
import { UI } from '../icons/ui-icons.ts';
import { useChooseName } from '../lib/queries.ts';
import { rt } from '../lib/runtime.ts';
import { STEWARDS_EMAIL } from '../lib/stewards.ts';
import { LegalLinks, Masthead } from './Layout.tsx';
import { ErrorNotice } from './Notice.tsx';
import { PageTitle } from './ui.tsx';

/** In place of the game after a steward has taken the player's name away, until they choose another. */
export function ChooseName({ oldName, reason }: { oldName: string; reason: string }) {
  const [name, setName] = useState('');
  const choose = useChooseName();
  return (
    <div className="mx-auto flex min-h-dvh max-w-2xl flex-col px-4">
      <header className="border-b border-rule py-3"><Masthead /></header>
      <main className="panel my-10 space-y-4">
        <PageTitle icon={UI.rename}>Choose a new name</PageTitle>
        <p>
          A steward has taken the name <span className="text-ochre">{oldName}</span> away under the <a className="text-gilt underline" href="/rules" target="_blank">rules</a>:
        </p>
        <blockquote className="border-l-2 border-blood pl-3 text-ink-dim">{reason}</blockquote>
        <p>Everything else is as you left it. Choose a new name to carry on.</p>
        <form
          className="flex flex-wrap gap-2"
          onSubmit={(e) => {
            e.preventDefault();
            if (name.trim()) choose.mutate(name);
          }}
        >
          <input className="field min-w-0 flex-1" aria-label="New name" placeholder="Alys Fletcher" maxLength={40} value={name} onChange={(e) => setName(e.target.value)} autoFocus />
          <button type="submit" className="btn" disabled={choose.isPending || !name.trim()}>Take this name →</button>
        </form>
        <ErrorNotice error={choose.error} />
        <p className="text-sm text-ink-dim">
          If you think this is wrong, write to <a className="text-gilt underline" href={`mailto:${STEWARDS_EMAIL}`}>{STEWARDS_EMAIL}</a>. A steward will read it.
        </p>
        <button type="button" className="btn-quiet" onClick={() => rt().auth.signOut()}>Sign out</button>
      </main>
      <footer className="flex text-xs text-ink-faint"><LegalLinks /></footer>
    </div>
  );
}
